export const MOPED = {
  nickname: 'PRODUCTS.MOPED.nickname',
  properties: [
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO' },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO' },
    { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO' },
    { name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR', group: 'OBJECT_INFO' },
    { name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'INSURANCE_INFO' },
  ]
};
